import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    open:false,
    dialogtype: 0,  //0:Normal 1:名前を付けて保存 9:カスタム
    title: '',
    contents:null,
    contents2: null,
    contents3: null,
    placeholder: '',
    checkboxlabel:'',
    cmdlabel: '実行',
    inputname: '値',
    textarea:false,
    defaultvalue: '',
    inputhide:false,
    customcontents:null,  //カスタムコンテンツNo
    onApply:null
};

const formdlgSlice = createSlice({
    name: 'formdlg',
    initialState,
    reducers: {
        formdlgopen: (state, action) => {
            return Object.assign({}, state, {
                open: true,
                dialogtype: action.payload.dialogtype,
                title: action.payload.title,
                contents: action.payload.contents,
                contents2: action.payload.contents2,
                contents3: action.payload.contents3,
                placeholder: action.payload.placeholder,
                checkboxlabel: action.payload.checkboxlabel,
                cmdlabel: action.payload.cmdlabel,
                inputname: action.payload.inputname,
                defaultvalue: action.payload.defaultvalue === undefined? '':action.payload.defaultvalue,
                textarea: action.payload.textarea === undefined ? false : action.payload.textarea,
                inputhide: action.payload.inputhide === undefined ? false : action.payload.inputhide,
                customcontents: action.payload.customcontents === undefined ? null: action.payload.customcontents,
                onApply: action.payload.onApply
            })
        },
        formdlgclose: (state, action) => {
            return initialState
        }
    },
});

export const {
    formdlgopen, formdlgclose
} = formdlgSlice.actions

export default formdlgSlice;

